import React from 'react';
import RadioGroup, { RadioOption } from 'components/UI/V3/Forms/RadioGroup/RadioGroup';
import styles from './TransportationTypeSelector.module.scss';
import clsx from 'clsx';

export type TransportationType = 'pickup' | 'dropoff' | 'roundtrip' | undefined;

interface Props {
    value: TransportationType;
    edit: boolean;
    onChange: (value: TransportationType) => void;
}

export const TransportationTypeSelector: React.FC<Props> = ({ value, edit, onChange }) => {
    const options: RadioOption<TransportationType>[] = [
        { value: 'pickup', inlineLabel: 'Pick Up' },
        { value: 'dropoff', inlineLabel: 'Drop Off' },
        { value: 'roundtrip', inlineLabel: 'Round Trip' }
    ];

    return (
        <>
            <label className={styles.label}>Transportation Type</label>
            <RadioGroup
                value={value}
                options={options}
                onChange={onChange}
                className={clsx(styles.radioGroup, { [styles.edit]: edit })}
            />
        </>
    );
};

export default TransportationTypeSelector;
